import styles from './AppHeader.module.css'
import logo2x from './../../../image/logo2x.png'
import logo from './../../../image/logo.png'
import logoMain from './images/ic_logo_main.png'
import logoMain2x from './images/ic_logo_main2x.png'
import bicycle from './images/ic_bicycle.png'
import bicycle2x from './images/ic_bicycle2x.png'
import run from './images/ic_run.png'
import run2x from './images/ic_run2x.png'
import skis from './images/ic_skis.png'
import skis2x from './images/ic_skis2x.png'
import swiming from './images/ic_swiming.png'
import swiming2x from './images/ic_swiming2x.png'
import walk from './images/ic_walk.png'
import walk2x from './images/ic_walk2x.png'
import {TextGradient} from "../../textGradient/TextGradient";
import { BackButton } from '../../backButton/BackButton';
import { useEffect, useState } from 'react';
import { ActivityType, userLogin } from '../../../models/commonModels';
import { useAppSelector } from '../../../hooks/redux';

export const AppHeader =({isMaim}:{isMaim:boolean})=>{
    const [user,setUser] = useState<userLogin|null>(()=>{
            const savedUser = localStorage.getItem("currentUser")
            if(savedUser==null) return null;
            const initialValue:userLogin = JSON.parse(savedUser)
            return initialValue;})
            const activityTab = useAppSelector(state=>state.appStore.activity_type)
                const [currentHeaderImage, setCurrentHeaderImage]=useState(logoMain)//десктоп
                const [currentHeaderImage2x, setCurrentHeaderImage2x]=useState(logoMain)//мобилка
                useEffect(()=>{
                    switch(activityTab){
                        case ActivityType.RUN : 
                            setCurrentHeaderImage(run)
                            setCurrentHeaderImage2x(run2x)
                            break;
                        case ActivityType.BICYCLE : 
                            setCurrentHeaderImage(bicycle)
                            setCurrentHeaderImage2x(bicycle2x)
                            break;
                        case ActivityType.SKIS : 
                            setCurrentHeaderImage(skis)
                            setCurrentHeaderImage2x(skis2x)
                            break;  
                        case ActivityType.SWIMMING : 
                            setCurrentHeaderImage(swiming)
                            setCurrentHeaderImage2x(swiming2x)
                            break;
                        case ActivityType.WALK: 
                            setCurrentHeaderImage(walk)
                            setCurrentHeaderImage2x(walk2x)
                            break;       
                    }
                },[activityTab])
    return(
        <div className={styles.app_header}>
            {!user&&<BackButton/>}
            <div>
                <span className={styles.app_header_logo}>
                    {isMaim==true&&<img src={logoMain}/>}
                    {isMaim==false&&<img src={currentHeaderImage}/>}
                </span>
                <div className={styles.app_header_logo_mobile}>
                    {isMaim==true&&<img src={logoMain2x} style={{width:"100%",height:"auto"}}/>}
                    {isMaim==false&&<img src={currentHeaderImage2x} style={{width:"100%",height:"auto"}}/>}
                </div>
                <div className={styles.app_header_slogan_container}>
                    {/* <div className={styles.app_header_slogan}>
                        <TextGradient
                            colors={["#739E72","#1C6A93","#F65B3E"]}
                            text={"БЕГОВЫХ КИЛОМЕТРОВ"}
                            fontSize={"28px"} fontWeigth={"400"}/>
                    </div>
                    <div className={styles.app_header_slogan_min}>
                        <TextGradient
                            colors={["#739E72","#1C6A93","#F65B3E"]}
                            text={"БЕГОВЫХ КИЛОМЕТРОВ"}
                            fontSize={"24px"} fontWeigth={"400"}/>
                    </div> */}
                </div>
            </div>
        </div>

    )
}